import { IDto } from "@interfaces/dto"
import { Pricing } from "@models/pricing"
import { ChargingstationGroup } from "./chargingstationGroup"
import { ChargingPowerProfile } from "@models/chargingPowerProfile"
import { ChargingStationStatus } from "@models/chargingStationStatus"

export class TransactionDto implements IDto {
  id?: number
  transactionId?: number

  startTimestamp: Date
  stopTimestamp: Date
  fromToDate: string

  meterStart: number
  meterStop: number
  meterAmount: number
  success?: number
  successMessage: string
  reason?: string
  price: number = 0
  lastUpdated?: Date

  chargingStationId?: string
  chargingStationName?: string
  chargingStationGroups: ChargingstationGroup[]
  connectorId?: number
  chargingStationNumberOfChargingPoints?: number

  rfidCardId: number
  rfidCardIdTag?: string

  userId: string
  userFirstName: string
  userLastName: string

  pricingId: number
  pricing: Pricing
  invoiceId: number

  duration: string
  isFreeCharge: boolean
  paymentIntentId: string
  hecId?: string

  chargeDiameter?: any

  chargingPowerProfile?: ChargingPowerProfile
  status?: ChargingStationStatus // this is meant to represent a compound status of charging station and charging point.
  currentMeter?: number // null if no meter value has been received yet. This field is missing in the C# DTO (unknown reason).
  currentSoC: string
  currentPower: string

  sessionId?: string

  entityName = "TransactionDto"

  constructor(formValue?: Partial<TransactionDto>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<TransactionDto>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
